<div class="invalid-feedback" [style.display]="!_hide ? 'block' : 'none'">
    <span class="material-icons">error_outline</span>
    {{ _text }}
</div>
